exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contract[data-v-260e0d56] {\r\n  font-family: monospace;\r\n  height: auto;\r\n  max-height: 150%;\r\n  overflow: auto;\n}\r\n", ""]);

// exports
